"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const executionStep_1 = require("./executionStep");
class Execution {
  constructor(workflow, execution, stepIds = []) {
    this.workflow = workflow;
    this.execution = "";
    this.steps = stepIds.map(id => new executionStep_1.ExecutionStep(id));
  }
  async fetchExecutionData(dataResolver) {
    if (this.execution) {
      await this.fetchSteps(dataResolver);
    } else {
      await this.fetchLatestExecution(dataResolver);
    }
  }
  setUpdateListener(listener) {
    this.updateListener = listener;
  }
  setStepData(steps) {
    for (const s of steps) {
      const { name, input, output, status = "Waiting" } = s;
      let stepIndex = this.steps.findIndex(step => step.stepId === name);
      if (stepIndex === -1) continue;
      let step = this.steps[stepIndex];
      step.setStatus(status.toLowerCase());
      if (input.parentNodeId) step.setParentId(input.parentNodeId);
      if (step.getStatus() === "failed") {
        this.markFollowingAsCompleted(step.stepId);
      }
      if (step.getParentId() && step.getStatus() === "failed") {
        const parentStep = this.steps.find(
          s => s.stepId === step.getParentId()
        );
        if (parentStep) this.markFollowingAsCompleted(parentStep.stepId);
      }
      let inputMessage = input && input.previousAction;
      let outputMessage =
        output && output.meta && output.meta.step && output.meta.step.message;
      step.setInputMessage(
        inputMessage || (stepIndex === 1 ? "Input" : "Previous Output")
      );
      step.setOutputMessage(outputMessage || status);
    }
  }
  getStep(id) {
    return this.steps.find(e => e.stepId === id);
  }
  getInternalStep(id) {
    return this.steps.filter(e => e.getParentId() === id);
  }
  async fetchLatestExecution(dataResolver) {
    let data = await dataResolver.resolve("getWorkflowExecutionHistory", {
      workflow: this.workflow,
      limit: 1
    });
    if (data.length) {
      const { execution } = data[0];
      this.execution = execution;
      await this.fetchSteps(dataResolver);
    } else {
      await waitForSeconds(3);
      await this.fetchExecutionData(dataResolver);
    }
  }
  async fetchSteps(dataResolver) {
    let { history, endDate } = await dataResolver.resolve(
      "getExecutionSteps",
      this.execution
    );
    if (history) {
      this.setStepData(history);
      this.updateListener && this.updateListener();
    }
    if (!endDate) {
      await waitForSeconds(10);
      await this.fetchExecutionData(dataResolver);
    }
  }
  markFollowingAsCompleted(stepId) {
    let index = this.steps.findIndex(s => s.stepId === stepId);
    for (let i = index + 1; i < this.steps.length; i++) {
      let step = this.steps[i];
      // Only marker abandoned which step are directly visible
      if (!step.getParentId()) {
        step.setStatus("abandoned");
        step.setInputMessage("Did not run since previous steps have error");
        step.setOutputMessage("Did not run since previous steps have error");
      }
    }
  }
}
exports.Execution = Execution;
function waitForSeconds(timeoutInSeconds) {
  return new Promise(resolve => setTimeout(resolve, timeoutInSeconds * 1000));
}
//# sourceMappingURL=execution.js.map
